// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rmapd5NwfXpePPWo_G49 {
  width: 100%;
  display: flex;
  grid-gap: 2.5rem;
  gap: 2.5rem;
}

.lkj9ppKn_0LxXRR__L7P {
  flex: 1
}

.lkj9ppKn_0LxXRR__L7P img {
    width: 100%;
    height: auto;
    max-height: 22.1875rem;
    object-fit: cover;
    box-shadow: var(--black-012);
    border-radius: var(--panel-border-radius);
  }

.EuIm8LFm2ro6GoIg3hTO {
  flex: 1;
}

._EJ4WmsoZ1L6dWwbOsFK {
  font-size: 2rem;
  line-height: 2.25rem;
}

.Cpgo8d0Ke6vpJYs6uIzA {
  margin: 2.5rem 0;
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  ._EJ4WmsoZ1L6dWwbOsFK {
    font-size: 1.75rem;
    line-height: 2.1875rem;
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .rmapd5NwfXpePPWo_G49 {
    flex-direction: column-reverse;
    grid-gap: 0;
    gap: 0;
  }

  ._EJ4WmsoZ1L6dWwbOsFK {
    font-size: 1.5rem;
    line-height: 1.75rem;
  }

  .Cpgo8d0Ke6vpJYs6uIzA {
    margin: 1.5rem 0 0 0;
  }

  .lkj9ppKn_0LxXRR__L7P {
    margin: 1rem 0
  }

    .lkj9ppKn_0LxXRR__L7P img {
      max-height: 12.5rem;
    }
}

@media only screen and
  (max-width: 639px) {
  .rmapd5NwfXpePPWo_G49 {
    flex-direction: column-reverse;
    grid-gap: 0;
    gap: 0;
  }

  .Cpgo8d0Ke6vpJYs6uIzA {
    margin: 1.5rem 0 0 0;
  }

  .lkj9ppKn_0LxXRR__L7P {
    margin: 1rem 0
  }

    .lkj9ppKn_0LxXRR__L7P img {
      max-height: 10.875rem;
      min-height: unset;
    }

  ._EJ4WmsoZ1L6dWwbOsFK {
    font-size: 1.5rem;
    line-height: 1.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ContentBlock/ContentBlock.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,gBAAS;EAAT,WAAS;AACX;;AAEA;EACE;AAUF;;AARE;IACE,WAAW;IACX,YAAY;IACZ,sBAAiB;IACjB,iBAAiB;IACjB,4BAA4B;IAC5B,yCAAyC;EAC3C;;AAGF;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,oBAAiB;AACnB;;AAEA;EACE,gBAAc;AAChB;;AAEA;;;EACE;IACE,kBAAe;IACf,sBAAiB;EACnB;AACF;;AAEA;;;EACE;IACE,8BAA8B;IAC9B,WAAM;IAAN,MAAM;EACR;;EAEA;IACE,iBAAe;IACf,oBAAiB;EACnB;;EAEA;IACE,oBAAkB;EACpB;;EAEA;IACE;EAKF;;IAHE;MACE,mBAAiB;IACnB;AAEJ;;AAEA;;EACE;IACE,8BAA8B;IAC9B,WAAM;IAAN,MAAM;EACR;;EAEA;IACE,oBAAkB;EACpB;;EAEA;IACE;EAMF;;IAJE;MACE,qBAAiB;MACjB,iBAAiB;IACnB;;EAGF;IACE,iBAAe;IACf,oBAAiB;EACnB;AACF","sourcesContent":[".contentBlock {\n  width: 100%;\n  display: flex;\n  gap: 40px;\n}\n\n.imageContainer {\n  flex: 1;\n\n  & img {\n    width: 100%;\n    height: auto;\n    max-height: 355px;\n    object-fit: cover;\n    box-shadow: var(--black-012);\n    border-radius: var(--panel-border-radius);\n  }\n}\n\n.content {\n  flex: 1;\n}\n\n.title {\n  font-size: 32px;\n  line-height: 36px;\n}\n\n.text {\n  margin: 40px 0;\n}\n\n@media (--desktop-small) {\n  .title {\n    font-size: 28px;\n    line-height: 35px;\n  }\n}\n\n@media (--tablet) {\n  .contentBlock {\n    flex-direction: column-reverse;\n    gap: 0;\n  }\n\n  .title {\n    font-size: 24px;\n    line-height: 28px;\n  }\n\n  .text {\n    margin: 24px 0 0 0;\n  }\n\n  .imageContainer {\n    margin: 16px 0;\n\n    & img {\n      max-height: 200px;\n    }\n  }\n}\n\n@media (--mobile) {\n  .contentBlock {\n    flex-direction: column-reverse;\n    gap: 0;\n  }\n\n  .text {\n    margin: 24px 0 0 0;\n  }\n\n  .imageContainer {\n    margin: 16px 0;\n\n    & img {\n      max-height: 174px;\n      min-height: unset;\n    }\n  }\n\n  .title {\n    font-size: 24px;\n    line-height: 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentBlock": `rmapd5NwfXpePPWo_G49`,
	"imageContainer": `lkj9ppKn_0LxXRR__L7P`,
	"content": `EuIm8LFm2ro6GoIg3hTO`,
	"title": `_EJ4WmsoZ1L6dWwbOsFK`,
	"text": `Cpgo8d0Ke6vpJYs6uIzA`
};
export default ___CSS_LOADER_EXPORT___;
